import React from 'react';
import { motion } from 'framer-motion';
import { FiShield, FiBriefcase, FiHome, FiCheckCircle, FiPlay } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const verticals = [
  { name: 'SSDI CALLS', icon: FiShield },
  { name: 'CPA CALLS', icon: FiBriefcase },
  { name: 'HOME SERVICES', icon: FiHome }
];

const Hero = () => {
  return (
    <div className="relative min-h-screen bg-slate-950 flex items-center justify-center overflow-hidden px-6">
      {/* 3D Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 -left-20 w-96 h-96 bg-indigo-600/10 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-purple-600/10 rounded-full blur-[120px]"></div>
      </div>

      <div className="max-w-4xl mx-auto w-full relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-indigo-500/10 border border-indigo-500/30 text-indigo-400 text-xs font-bold uppercase tracking-widest mb-10">
            <SafeIcon icon={FiCheckCircle} className="text-sm" />
            Direct Advertiser Network
          </div>

          <h1 className="text-5xl md:text-8xl font-black text-white leading-[0.9] tracking-tighter mb-12 italic uppercase">
            WE DEAL WITH <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400">
              HIGH-INTENT CALLS
            </span>
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
            {verticals.map((v, i) => (
              <motion.div
                key={v.name}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: i * 0.1 + 0.5 }}
                className="bg-white/5 border border-white/10 p-6 rounded-3xl backdrop-blur-sm hover:border-indigo-500/50 transition-colors group"
              >
                <div className="w-12 h-12 bg-indigo-600/20 rounded-2xl flex items-center justify-center mb-4 mx-auto group-hover:scale-110 transition-transform">
                  <SafeIcon icon={v.icon} className="text-2xl text-indigo-400" />
                </div>
                <h3 className="text-white font-black text-sm tracking-widest">{v.name}</h3>
              </motion.div>
            ))}
          </div>

          <p className="text-2xl text-slate-400 max-w-2xl mx-auto leading-relaxed font-medium">
            We operate exclusively with <span className="text-white font-bold border-b-2 border-indigo-500">Direct Advertisers</span> to ensure maximum ROI and premium traffic quality.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;